// extracted by mini-css-extract-plugin
export var container = "tokenomics-module--container--y+BFJ";
export var title = "tokenomics-module--title--kAZkW";
export var gridContainer = "tokenomics-module--gridContainer--uLZOr";
export var imageDiv = "tokenomics-module--imageDiv--SdHEo";
export var gridItem = "tokenomics-module--gridItem--6rNDN";
export var image = "tokenomics-module--image--imAQG";
export var anchor = "tokenomics-module--anchor--zBkt-";
export var textTokenomics = "tokenomics-module--textTokenomics--D68pk";